import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

interface Props {
  metaDescription: string;
  title: string;
  lang: string;
  meta: any;
}

function SEO({ metaDescription, lang, meta, title }: Props): JSX.Element {
  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: 'viewport',
          content:
            'minimum-scale=1, initial-scale=1, width=device-width, shrink-to-fit=no',
        },
      ].concat(meta)}
    />
  );
}

SEO.defaultProps = {
  lang: `no`,
  meta: [],
  metaDescription: ``,
};

SEO.propTypes = {
  metaDescription: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
};

export default SEO;
